<div>

  <div class="dienstleistungsart-toolbar">
    <mat-form-field redispatchProvideReadonly>
      <mat-label>Filter</mat-label>
      <input matInput data-qa="filter" (keyup)="applyFilter($event)" #input>
      <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
    </mat-form-field>

    <div class="buttons">
      <button matButton="filled" class="actionbutton" data-qa="create-button" (click)="createDienstleistungsArt()">
        <mat-icon>add</mat-icon>
        Neue Dienstleistungsart
      </button>
    </div>
  </div>

  <table [dataSource]="dienstleistungsartList"
    mat-table
    class="dienstleistungsart-table"
    data-qa="data-table">

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr style="cursor: pointer" mat-row *matRowDef="let dlArt; columns: columnsToDisplay"
    (click)="openDienstleistungsArt(dlArt)"></tr>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let dlArt;">{{dlArt.title}}</td>
    </ng-container>

    <ng-container matColumnDef="dienstleistungsmoduleBeschreibung">
      <th mat-header-cell *matHeaderCellDef>Anz. Dienstleistungsmodule</th>
      <td mat-cell *matCellDef="let dlArt;" class="no-wrap">
        <span>{{dlArt.dienstleistungsmoduleBeschreibung.length}}</span>
        <div class="menu-container" [mat-menu-trigger-for]="menu" #menuTrigger="matMenuTrigger"
          [matMenuTriggerRestoreFocus]="true">
          <mat-icon
            svgIcon="innogy_picto_speech-bubble_exclamationmark"
            (mouseenter)="menuTrigger.openMenu(); menuTrigger.focus()"
            (mouseleave)="menuTrigger.closeMenu()">
          </mat-icon>
        </div>

        <mat-menu #menu="matMenu" [hasBackdrop]="false" class="no-max-width show-active">
          @for (module of dlArt.dienstleistungsmoduleBeschreibung; track module.id) {
            <span mat-menu-item disabled>
              {{module.title}}
            </span>
          }
          @if (dlArt.dienstleistungsmoduleBeschreibung.length === 0) {
            <span mat-menu-item disabled>
              Keine Dienstleistungsmodule ausgewählt
            </span>
          }
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>Notizen</th>
      <td mat-cell *matCellDef="let dlArt;">{{dlArt.notes}}</td>
    </ng-container>

  </table>
</div>
